import './themes/styles.css'
import React from 'react'
import {AppContextProvider} from './contexts/AppContextProvider'
import LoginCheck from './components/LoginCheck'
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import LocalizationProvider from '@mui/lab/LocalizationProvider'
import DataRetrieval from './components/DataRetrieval'
import {getLocaleFile} from './lib/locale-helpers'
import AppRouter from './routers/AppRouter'
import {OrgCustomizationProvider} from "./themes/OrgCustomizationProvider";
import NotificationProvider from "./components/NotificationProvider";
import GoogleAnalytics from "./contexts/GoogleAnalytics";

const App: React.FC = () => (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={getLocaleFile()}>
        <OrgCustomizationProvider>
            <GoogleAnalytics>
                <AppContextProvider shouldClearSessionAfterSubmission={true}>
                    <LoginCheck>
                        <DataRetrieval shouldRetrieveData={true}>
                            <NotificationProvider>
                                <AppRouter/>
                            </NotificationProvider>
                        </DataRetrieval>
                    </LoginCheck>
                </AppContextProvider>
            </GoogleAnalytics>
        </OrgCustomizationProvider>
    </LocalizationProvider>
)

export default App
